module.exports = __webpack_public_path__ + "static/banner-dab01c3b6c12ad17cdaa7f3eab498a6f.jpeg";